<app-loading
[loading] = loading
></app-loading>

<div class="modal-overlay" *ngIf="habilitarNovo" (click)="!loading && fecharModalNovo()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-users"></i> Novo Cliente
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModalNovo()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>

    <form [formGroup]="formAdicionarCliente" class="row g-3">
      <div class="col-md-12">
        <label for="nome" class="form-label">Nome</label>
        <input type="text" formControlName="nome" id="nome"
               [ngClass]="{'is-invalid': formAdicionarCliente.get('nome')?.invalid && formAdicionarCliente.get('nome')?.touched}"
               placeholder="Digite o nome do Cliente" class="form-control">
        <span class="error mensagem-erro"
              *ngIf="formAdicionarCliente.get('nome')?.touched &&
                    formAdicionarCliente.get('nome')?.errors?.required"
        >O nome não pode ser vazio <br></span>
      </div>

      <div class="col-md-12">
        <label for="tipoDocumento" class="form-label">Tipo de Documento</label>
        <ng-select (change)="habilitarDocumento()"
                   [ngClass]="{'is-invalid': formAdicionarCliente.get('tipoDocumento')?.invalid && formAdicionarCliente.get('tipoDocumento')?.touched}"
                   formControlName="tipoDocumento"
                   [items]="tipoDocumentos"
                   bindLabel="descricao"
                   bindValue="id"
                   [clearable]="false"
                   placeholder="Selecione o tipo do documento"
                   id="tipoDocumento">
        </ng-select>
        <span class="error mensagem-erro"
              *ngIf="formAdicionarCliente.get('tipoDocumento')?.touched &&
                    formAdicionarCliente.get('tipoDocumento')?.errors?.required"
        >O tipo de documento deve ser selecionado <br></span>
      </div>

      <div class="col-md-12">
        <label for="documento" class="form-label">Documento</label>
        <input type="text" [mask]="mascaraDocumento"
               [ngClass]="{'is-invalid': formAdicionarCliente.get('documento')?.invalid && formAdicionarCliente.get('documento')?.touched}"
               formControlName="documento" id="documento"
               placeholder="Digite o documento" class="form-control">
        <span class="error mensagem-erro"
              *ngIf="formAdicionarCliente.get('documento')?.touched &&
                    formAdicionarCliente.get('documento')?.errors?.required"
        >O documento não pode ser vazio <br></span>
      </div>

      <div class="col-md-12">
        <label for="telefone" class="form-label">Telefone</label>
        <input type="text" id="telefone"
               [ngClass]="{'is-invalid': formAdicionarCliente.get('telefone')?.invalid && formAdicionarCliente.get('telefone')?.touched}"
               formControlName="telefone"
               mask="(00) 0 0000-0000||(00) 0000-0000"
               placeholder="Digite o telefone" class="form-control">
        <span class="error mensagem-erro"
              *ngIf="formAdicionarCliente.get('telefone')?.touched &&
                    formAdicionarCliente.get('telefone')?.errors?.required"
        >O telefone não pode ser vazio <br></span>
      </div>

      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" (click)="cancelar()" class="btn btn-light" [disabled]="loading">Cancelar</button>
        <button type="button" (click)="salvar()" class="btn btn-primary px-4 d-flex align-items-center gap-2" [disabled]="loading || formAdicionarCliente.invalid">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ loading ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </form>
  </div>
</div>
